import React, { useState } from 'react'
import { POST } from '../../../helpers/httphelper'
import { toast as superToast } from 'bulma-toast'


function ShareMedicalRecord() {

  const [generated, setgenerated] = useState(false)
  const [channeling, setchanneling] = useState(true)
  const [medicine, setmedicine] = useState(false)
  const [lab, setlab] = useState(false)
  const [token, settoken] = useState('')
  const [expire, setexpire] = useState('')
  const [email, setemail] = useState('')
  const [viaemail, setviaemail] = useState(false)
  const uid = localStorage.getItem("user")
  const showmodal = () => {
    document.getElementById("modal").classList.add("is-active")
  }

  const hidemodal = () => {
    document.getElementById("modal").classList.remove("is-active")
    setgenerated(false)
  }

  const copyCode = () => {
    navigator.clipboard.writeText(token)
    superToast({
      message: 'Token Copeid',
      type: 'is-success',
      dismissible: true,
      position: "top-center",
      animate: { in: 'fadeIn', out: 'fadeOut' },
    })
  }

  const generateToken = (e) => {
    e.preventDefault()
    if (channeling === false && medicine === false && lab === false) {
      superToast({
        message: 'At least one Ckeckbox need to be checked',
        type: 'is-danger',
        dismissible: true,
        position: "top-center",
        animate: { in: 'fadeIn', out: 'fadeOut' },
      })
      return
    }
    if (viaemail) {
      if (email === '') {
        superToast({
          message: 'Email Required',
          type: 'is-danger',
          dismissible: true,
          position: "top-center",
          animate: { in: 'fadeIn', out: 'fadeOut' },
        })
        return
      }
    }
    const to = Math.floor((Math.random() * 999999) + 100000).toString()
    settoken(to)

    const ob = {
      uid,
      channeling,
      medicine,
      lab,
      expire,
      token: to,
      email,
      viaemail
    }
    POST('api/token/create', ob).then(data => {
      console.log(data)
      setchanneling(true)
      setgenerated(true)
      setmedicine(false)
      setlab(false)
      setviaemail(false)
    }).catch(err => {
      console.log(err)
    })

  }
  return (
    <div>

      <button className='button is-primary subtitle is-5'
        style={{ backgroundColor: '#F8813E', borderRadius: '10px', marginTop: '-20px', marginRight: '30px' }}
        onClick={(e) => { showmodal() }}>
        Share Medical Record
      </button>
      <div className="modal" id='modal'>
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head has-background-success">
            <p className="modal-card-title has-text-centered" style={{ color: "white" }}>Share Medicle Records</p>
            <button className="delete" onClick={(e) => { hidemodal() }} aria-label="close"></button>
          </header>
          <section className="modal-card-body">
            <form onSubmit={generateToken}>
              <div className='columns is-multiline'>

                {
                  generated ? <></> : <>
                    <div className='column is-12'>
                      <h1 className='has-text-centered'>Select Categories you want to share</h1>
                    </div>

                    <div className='column is-12'>
                      <div className='columns is-justify-content-center'>
                        <div className='column is-3'>
                          <label className="checkbox">
                            <input type="checkbox" onClick={(e) => { setmedicine(!medicine) }} className='mr-3' />
                            Medicines
                          </label>
                        </div>

                        <div className='column is-3'>
                          <label className="checkbox">
                            <input type="checkbox" onClick={(e) => { setlab(!lab) }} className='mr-3' />
                            Labs
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className='column is-12'>
                      <div className='columns is-justify-content-center'>
                        <div className='column is-6'>
                          <div className="field">
                            <label className="label">Token Expire Date</label>
                            <div className="control">
                              <input required className="input is-info" onChange={(e) => { setexpire(e.target.value) }} type="date" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='columns is-justify-content-center'>
                        <div className='column is-4'>
                          <label className="checkbox">
                            <input type="checkbox" onClick={(e) => { setviaemail(!viaemail) }} className='mr-3' />
                            Send Code Via Email
                          </label>
                        </div>
                      </div>
                      {viaemail ? <>
                        <div className='columns is-justify-content-center'>
                          <div className='column is-6'>
                            <div className="field">
                              <label className="label">Reciever's Email</label>
                              <div className="control">
                                <input className="input is-info" onChange={(e) => { setemail(e.target.value) }} type="email" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </> : <></>}
                    </div>
                  </>
                }
                <div className='column is-12'>
                  {
                    generated ? <><h1 className='has-text-centered is-2 title code' onClick={(e) => { copyCode() }}>{token}</h1><h1 className='has-text-centered'>Now you can share this code with the Doctor</h1><h1 className='has-text-centered'><a href onClick={(e) => { hidemodal() }} className='button is-danger mt-3'>Close</a></h1></> : <><h1 className='has-text-centered'> <button className="button is-success" type='submit'>Genereate Token</button></h1></>
                  }
                </div>

              </div>
            </form>
          </section>
        </div>
      </div >
    </div >


  )
}

export default ShareMedicalRecord;
